import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutContactLookup extends Layout {
    sourceContact: DataSource;
    tableContactLookup: Table;
}
